import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { MODULE_NAMES } from "../../resources/menu";
import { MdLockOutline } from "react-icons/md";

/**
 * 無權限頁面。
 *
 * 為什麼需要它：側欄把沒權限的項目藏起來，但路由本身原本沒有守衛 ——
 * 直接輸入網址（或從舊書籤、通知連結進來）照樣會渲染那一頁，
 * 然後所有 API 回 403，畫面停在空白或一整排紅字錯誤，
 * 使用者會以為系統壞了，而不是自己沒被授權。
 *
 * 這裡明講「沒有權限」並給一條回得去的路，比空白畫面誠實得多。
 */
function NoPermission({ permission }) {
  const navigate = useNavigate();
  const moduleName = MODULE_NAMES[permission] || permission;

  return (
    <Box
      sx={{
        minHeight: 420,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        textAlign: "center",
        py: 5,
        px: 2.5,
      }}
    >
      <Avatar variant="rounded" sx={{ width: 64, height: 64, borderRadius: "var(--radius-md)", bgcolor: "action.hover", color: "text.disabled", fontSize: 30 }}>
        <MdLockOutline />
      </Avatar>

      <Typography variant="h2" component="h1">
        您沒有此頁面的權限
      </Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 420 }}>
        此頁面需要「{moduleName}」模組的檢視權限。
        <br />
        如因工作需要，請聯絡系統管理員於「角色與權限」中開通。
      </Typography>

      <Button variant="outlined" onClick={() => navigate("/Redirect", { replace: true })} sx={{ mt: 1 }}>
        返回可存取的頁面
      </Button>
    </Box>
  );
}

NoPermission.propTypes = { permission: PropTypes.string };
NoPermission.defaultProps = { permission: "" };

export default NoPermission;
